import React, {useEffect, useMemo, useState} from 'react';
import { Box, Grid, Typography, Container } from '@mui/material';
import { CharacterSidebar } from './simc/sidebar';
import { PasteArea } from './simc/paste';
import { ReportViewer } from './simc/viewer';
import { useSimCReports } from '../hooks/useReports';
import {Character, SimCReport} from '../types/simc';
import useWebSocket from "react-use-websocket";
import {WS} from "../services/api";

export const Dashboard: React.FC = () => {
    const [last, setLast] = useState<string | null>(null);
    const { sendMessage, lastMessage: recv, readyState } = useWebSocket(WS!, {
        shouldReconnect: (closeEvent) => true,
        reconnectAttempts: 42,
        reconnectInterval: 5000,
        disableJson: true
    });
    const { invalidate } = useSimCReports();

    useEffect(() => {
        if (recv !== null && recv.data) {
            setLast(recv.data);
        }
    }, [recv]);

    useEffect(() => {
        if (last !== null) {
            invalidate();
            setLast(null);
        }
    }, [last, invalidate, setLast]);

    useEffect(() => {
        if (readyState === 0) {
            sendMessage("hello world");
        }
    }, [readyState, sendMessage]);

    const [selectedCharacter, setSelectedCharacter] = useState<string | null>(null);
    const {
        reports,
        groupedReports,
        isLoading,
        uploadReport,
        deleteReport,
        isUploading,
        uploadError
    } = useSimCReports();

    console.log(WS, readyState);

    const handleSelectCharacter = (character: string) => {
        setSelectedCharacter(character);
    };

    const handleDeleteReport = (reportId: string) => {
        const report = reports.find((r: SimCReport) => r.id === reportId);
        if (report && selectedCharacter) {
            if (groupedReports.find(g => g.discord_id === report!.discord_id)!
                .characters.find(c => c.name === selectedCharacter)!
                .reports.filter(r => r.id !== reportId)
                .length === 0) {
                setSelectedCharacter(null);
            }
        }
        deleteReport(reportId);
    };

    const current = useMemo(() => {
        let character: Character | undefined = undefined;
        let group = groupedReports.find(g => {
            let char = g.characters.find(c => c.name === selectedCharacter);
            if (char) {
                character = char;
            }
            return !!char
        });
        return character;
    }, [selectedCharacter, groupedReports]);

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                SimC Report Manager
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Share and manage SimulationCraft character reports with your guild
            </Typography>

            <Grid container spacing={3} sx={{ height: 'calc(100vh - 200px)' }}>
                {/* Left Sidebar - Character List */}
                <Grid size={{ xs: 12, md: 3}}>
                    <CharacterSidebar
                        isLoading={isLoading}
                        characterGroups={groupedReports}
                        onSelectCharacter={handleSelectCharacter}
                        selectedCharacter={selectedCharacter || undefined}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 9}}>
                    <PasteArea
                        onUpload={uploadReport}
                        isUploading={isUploading}
                        uploadError={uploadError}
                    >{selectedCharacter && <ReportViewer
                        character={current!}
                        onDeleteReport={handleDeleteReport} />
                    }
                    </PasteArea>
                </Grid>
            </Grid>
        </Container>
    );
};
